import { Component, ViewEncapsulation, inject, input } from '@angular/core';

import { AppearanceThemeModifierDirective } from '@frontend/casino-ui';
import { CasinoTheme, FeatureNames, UIElement } from '@frontend/casino-ui/shared';
import { DsPaginationIndicator } from '@frontend/ui/pagination-indicator';
import { SwiperComponent } from '@frontend/vanilla/shared/swiper';

import { UtilityService } from '../shared/utility.service';

@Component({
    selector: 'cc-custom-carousel-pagination',
    template: `
        <div class="swiper-custom-pagination">
            <div
                class="swiper-pagination swiper-pagination-bullets"
                [class.swiper-pagination-clickable]="!disableClick()"
                [class.pagination-alignment]="enableNewCarousel()">
                @if (enableNewCarousel()) {
                    @for (i of itemIndexes; track i) {
                        <ds-pagination-indicator
                            csAppearanceThemeModifier
                            [featureName]="featureName"
                            [elementType]="carouselElementType"
                            [currentTheme]="currentTheme"
                            [selected]="i === currentIndex()"
                            (click)="paginationClick(i, $event)">
                        </ds-pagination-indicator>
                    }
                } @else {
                    @for (i of itemIndexes; track i) {
                        <span
                            class="swiper-pagination-bullet"
                            role="button"
                            [class.swiper-pagination-bullet-active]="i === currentIndex()"
                            (click)="paginationClick(i, $event)">
                        </span>
                    }
                }
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    imports: [DsPaginationIndicator, AppearanceThemeModifierDirective],
})
export class CustomCarouselPaginationComponent {
    loop = input<boolean>(true);
    disableClick = input<boolean>(false);
    noOfItems = input<number>();
    currentIndex = input<number>();
    carousel = input<SwiperComponent>();
    enableNewCarousel = input<boolean>(false);

    public carouselElementType: UIElement = 'paginationIndicator';
    public featureName: FeatureNames = FeatureNames.CUSTOMCAROUSEL;
    public currentTheme: CasinoTheme;
    private readonly utilityService = inject(UtilityService);

    ngOnInit() {
        this.currentTheme = this.utilityService.getCurrentTheme();
    }
    get itemIndexes(): number[] {
        const count = this.noOfItems() ?? 0;
        return Array.from({ length: count }, (_, i) => i);
    }

    paginationClick(index: number, event: Event) {
        if (this.disableClick() || this.currentIndex() === index) {
            event.stopPropagation();
            event.stopImmediatePropagation();
        } else {
            const i = index;
            const swiperInstance = this.carousel()?.swiper;
            if (!swiperInstance) return;
            const slideIndex = swiperInstance.slides?.length > i ? i : 0;
            if (swiperInstance?.params.loop) {
                if (swiperInstance?.realIndex === slideIndex) return;
                swiperInstance?.slideToLoop(slideIndex);
            } else {
                swiperInstance?.slideTo(slideIndex);
            }
        }
    }
}
